import { useContext } from 'react';

import { HotelContext } from 'app/context/HotelContext/HotelContext';
import { LegacyHotelContext } from 'app/context/HotelContext/LegacyHotelContext';
import { RateMode } from 'app/typings/rateModes';

import './PricingRule.scss';
import { PricingRuleModal } from './_components/PricingRuleModal';

type Props = {
  onClose: () => void;
  isOpen: boolean;
  onCompleteTask?: () => void;
};

export const PricingRule = ({ onClose, isOpen, onCompleteTask }: Props) => {
  const { hotelId, hotelInfo } = useContext(HotelContext);
  const { publishedPackages } = useContext(LegacyHotelContext);

  if (publishedPackages === undefined) {
    return <></>;
  }

  return (
    <PricingRuleModal
      onClose={onClose}
      isOpen={isOpen}
      onCompleteTask={onCompleteTask}
      hotelId={hotelId}
      isSingleRate={hotelInfo?.rateMode === RateMode.SINGLE_RATE}
      packages={publishedPackages.sort((l, r) => l.id - r.id)}
    />
  );
};
